<template>
  <div id="new-page">
    <h1 style="margin-top: 20px">Publish new terms</h1>
    <div>
      <table style="margin: 0 auto;margin-top: 20px">
        <tr>
          <td>
            <label>Version</label>
          </td>
          <td>
            <input type="text" v-model="version" :disabled="true" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Type</label>
          </td>
          <td>
            <input type="text" :value="type" :disabled="true" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Country</label>
          </td>
          <td>
            <select v-model="country">
              <option value="LT">Lithuania</option>
              <option value="PL">Poland</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <label>Title {{country}}</label>
          </td>
          <td>
            <input type="text" v-model="title[country.toLowerCase()]" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Body {{country}}</label>
          </td>
          <td>
            <div>Preview: <input type="checkbox" id="checkbox" v-model="preview" style="width: 50px" /></div>
            <textarea v-model="body[country.toLowerCase()]" v-if="!preview" />
            <MarkdownIt v-if="preview" class="mdown md-body" :content="body[country.toLowerCase()]" style="width: 400px;text-align:left" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Comment</label>
          </td>
          <td>
            <textarea v-model="comment" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Date</label>
          </td>
          <td>
            <DatePicker v-model="date" mode="datetime" />
          </td>
        </tr>
      </table>

      <button
        v-on:click="saveTerms()"
        style="background-color: #333;color: white; padding:10px;cursor:pointer;margin-top:20px;margin-bottom: 30px"
      >Publish new terms version</button>
    </div>
  </div>
</template>

<style scoped lang="less">
#new-page {
  input {
    padding: 10px;
    width: 700px;
  }
  textarea {
    width: 700px;
    height: 500px;
  }
  table {
    td {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
  .mdown {
    background-color: white;
    padding: 10px;
  }
}
</style>

<script>
import api from "../services/api";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import MarkdownIt from "markdown-it-vue";
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "home",
  components: { DatePicker, MarkdownIt },
  data: function () {
    return {
      country: 'LT',
      version: 1,
      type: 'b2bProTerms',
      date: new Date(),
      title: {
        lt: '',
        pl: ''
      },
      body: {
        lt: '',
        pl: ''
      },
      preview: false,
      comment: ''
    };
  },
  created: async function() {
    const terms = await api.getTerms();
    for (let i = 0; i < terms.length; i++) {
      const doc = terms[i];
      if (doc.id === this.$route.params.id) {
        this.country = doc.country;
        this.version = doc.version + 1;
        this.type = doc.type;
        this.title = doc.title;
        this.body = doc.body;
        this.comment = doc.comment;
      }
    }
  },
  methods: {
    saveTerms: async function () {
      const getEntryData = () => {
        return {
          country: this.country,
          type: this.type,
          title: this.title,
          body: this.body,
          date: this.date.getTime(),
          comment: this.comment,
        };
      };
      const data = getEntryData();
      await api.publishNewTerms(data);
      this.$router.push({ name: "terms" }).catch(() => {});
    },
  },
};
</script>
